import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { distinctUntilChanged, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BreakpointsService {

  readonly breakpoint$ = this.breakpointObserver
    .observe([
      Breakpoints.XLarge,
      Breakpoints.Large, 
      Breakpoints.Medium, 
      Breakpoints.Small, 
      Breakpoints.XSmall,
      '(min-width: 500px)'])
    .pipe(
      tap(value => console.log(value)),
      distinctUntilChanged()
    );   

  constructor(
    private breakpointObserver: BreakpointObserver
  ) { }


  public breakpointChanged() {
    let currentBreakpoint: string = '';
    if(this.breakpointObserver.isMatched(Breakpoints.XLarge)) {
      currentBreakpoint = Breakpoints.XLarge;
    } else if(this.breakpointObserver.isMatched(Breakpoints.Large)) {
      currentBreakpoint = Breakpoints.Large;
    } else if(this.breakpointObserver.isMatched(Breakpoints.Medium)) {
      currentBreakpoint = Breakpoints.Medium;
    } else if(this.breakpointObserver.isMatched(Breakpoints.Small)) {
      currentBreakpoint = Breakpoints.Small;
    } else if(this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
      currentBreakpoint = Breakpoints.XSmall;
    } else if(this.breakpointObserver.isMatched('(min-width: 500px)')) {
      currentBreakpoint = '(min-width: 500px)';
    }
    return currentBreakpoint;
  }

}

